module.exports = __webpack_public_path__ + "img/48.模型.5878336d.png";